<template>
<div id="poweredby">
  <slot></slot>
  <span v-for="(brand,index) in brands" :key="index">
    <a :href="brand.link" target="_blank" :title="brand.tip"><img :src="brand.image" /></a>
  </span>
</div>
</template>

<script>
  export default {
    name: 'PoweredByWidget',
    data () {
      return {
        brands: [
          {
            image: '/static/images/vendor/logo.png',
            title: 'VueJs',
            tip: 'The Progressive JavaScript Framework.',
            link: 'https://vuejs.org/'
          },
          {
            image: '/static/images/vendor/logo.svg',
            title: 'Vuetify',
            tip: 'Material Component Framework.',
            link: 'https://vuetify.com/'
          },

          {
            image: '/static/images/vendor/d3.png',
            title: 'D3',
            tip: 'Data-Driven Documents.',
            link: 'https://d3js.org/'
          },
          {
            image: '/static/images/vendor/dotnet_logo.png',
            title: 'dotnet',
            tip: '.NET Foundation',
            link: 'https://d3js.org/'
          },
          {
            image: '/static/images/vendor/small_v.png',
            title: 'docker',
            tip: 'Build, Ship, Run',
            link: 'https://d3js.org/'
          }

        ]
      }
    }
  }
</script>

<style scoped>
#poweredby img {
    height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/PoweredByWidget.vue